import { AddCard, Checklist, Dashboard, DesignServices, DisplaySettings, Email, EmojiPeople, Engineering, Logout, Paid, Person, Receipt, ReceiptLong, Settings, Work } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import React, { useState } from 'react'
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { useCommonUI } from '../context/UI';
import { useDispatch } from 'react-redux';
import { updateLogin } from '../store/slices/configSlice';
import { useApiRequest } from '../store/Common';
import { toast } from 'react-toastify';

function Navbar() {

    const {openDialog, openSnackbar} = useCommonUI();
    const {fetchData} = useApiRequest();
    const [collapsed, setCollapsed] = useState(false);
    const [isLogout, setIsLogout] = useState(false);
    const dispatch = useDispatch();

    const logoutOption = () =>{
        if(isLogout){
            openSnackbar('Logout in progress', 'error');
        }
        openDialog("Logout?", "Are you sure you want to Logout?", confirmLogout, null);
    }

    const confirmLogout = async() =>{
        const tid = toast.loading('Logging you out',{position:'bottom-right'});
        setIsLogout(true);
        const resp = await fetchData('app/logout');
        if(resp){
            dispatch(updateLogin(false));
            localStorage.removeItem('session');
            toast.update(tid, { render: "Logged Out", type: "success", isLoading: false, autoClose: 2000 });
        }else{
            toast.dismiss();
        }
        setIsLogout(false);
    }

    return (
        <Sidebar width='270px' collapsed={collapsed}  rootStyles={{height: '100vh'}}>
            <Menu
                menuItemStyles={{
                    button: {
                        [`&.active`]: {
                            backgroundColor: '#13395e',
                            color: '#b6c8d9',
                        },
                    },
                  }}
                >
                <Stack flexDirection={'row'} px={2} py={3} alignItems={'center'} gap={1}>
                    <IconButton onClick={() => setCollapsed(!collapsed)}>
                        <MenuIcon/>
                    </IconButton>
                    {!collapsed && <img src='/assets/logo-nav.png' alt='Startup Station' width='180px' />}
                </Stack>
                <MenuItem icon={<Dashboard />} component={<Link to={"/"} />}>Dashboard</MenuItem>
                <MenuItem icon={<EmojiPeople />} component={<Link to="/leads" />}>Leads</MenuItem>
                <MenuItem icon={<Person/>} component={<Link to="/customers" />}>Customers</MenuItem>
                <MenuItem icon={<DesignServices/>} component={<Link to="/services" />}>Services</MenuItem>
                <MenuItem icon={<Checklist/>} component={<Link to="/compliances" />}>Compliances</MenuItem>
                <MenuItem icon={<AddCard/>} component={<Link to="/addinvoice" />}>Add Invoice</MenuItem>
                <MenuItem icon={<Receipt/>} component={<Link to="/invoices" />}>Invoice</MenuItem>
                <MenuItem icon={<ReceiptLong/>} component={<Link to="/recurringinvoices" />}>Recurring Invoice</MenuItem>
                <MenuItem icon={<Paid/>} component={<Link to="/payments" />}>Payments</MenuItem>
                <MenuItem icon={<Email/>} component={<Link to="/templates" />}>Template</MenuItem>
                <MenuItem icon={<Work/>} component={<Link to="/accountantjobs" />}>Accountant Jobs</MenuItem>
                <MenuItem icon={<Engineering/>} component={<Link to="/users" />}>Users</MenuItem>
                <MenuItem icon={<DisplaySettings/>} component={<Link to="/compliancesettings" />}>Compliance Settings</MenuItem>
                <MenuItem icon={<Settings/>} component={<Link to="/settings" />}>Settings</MenuItem>
                <MenuItem onClick={logoutOption} icon={<Logout/>}>Logout</MenuItem>
            </Menu>
        </Sidebar>
    )
}

export default Navbar